(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chat-widget"] && !Shopify.designMode) return;
  try {
    /* The rule above only reaches the widget's own element: document stylesheets
     do not cross a shadow boundary, so everything inside it merely inherits the
     value. That falls apart the moment the chat is opened, because it swaps the
     activator for a <shopify-agent-runtime> carrying its own inline copy of the
     offset, and an inline declaration outranks anything inherited. Handing the
     shadow root a stylesheet of its own fixes it for good: an important
     declaration from inside beats the inline one, and keeps beating it however
     often the widget re-renders. */
  const fitChatToTheme = () => {
    const shadowRoot = document.querySelector('shopify-chat')?.shadowRoot;

    if (!shadowRoot) return false;

    const style = document.createElement('style');
    style.textContent =
      '* { --shopify-agent-activator-offset: calc(var(--space-md) + var(--sticky-bar-height, 0px)) !important; }';
    shadowRoot.append(style);

    return true;
  };

  /* the app embed boots on its own schedule, and lives where a MutationObserver
     on the document would not see it arrive */
  if (!fitChatToTheme()) {
    const startedAt = Date.now();
    const poll = setInterval(() => {
      if (fitChatToTheme() || Date.now() - startedAt > 15000) clearInterval(poll);
    }, 300);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collapsible-row"] && !Shopify.designMode) return;
  try {
    // Bursts oranges when a collapsible opens, and closes the sibling rows on
  // browsers without native `<details name>` exclusivity. The `toggle` event
  // does not bubble, so the listener runs in the capture phase.
  if (!window.collapsibleRowReady) {
    window.collapsibleRowReady = true;

    const supportsExclusive = 'name' in document.createElement('details');

    document.addEventListener(
      'toggle',
      (event) => {
        const row = event.target;
        if (!row.open || !row.hasAttribute?.('citrus-spill')) return;

        const group = row.getAttribute('name');
        if (!supportsExclusive && group) {
          document.querySelectorAll(`details[name="${group}"][open]`).forEach((other) => {
            if (other !== row) other.open = false;
          });
        }

        // burst from the row the visitor actually clicked
        const summary = row.querySelector('summary') || row;
        summary.dispatchEvent(new CustomEvent('citrus:spill', { bubbles: true }));
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-input')) {
    class QuantityInput extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.querySelector('[name="minus"]').addEventListener('click', () => this.step(-1));
        this.querySelector('[name="plus"]').addEventListener('click', () => this.step(1));
      }

      step(delta) {
        const min = this.input.min === '' ? 0 : Number(this.input.min);
        const max = this.input.max === '' ? Infinity : Number(this.input.max);
        const next = Math.min(max, Math.max(min, Number(this.input.value || 0) + delta));
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    customElements.define('quantity-input', QuantityInput);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('share-buttons')) {
    class ShareButtons extends HTMLElement {
      connectedCallback() {
        this.url = this.dataset.shareUrl;
        this.title = this.dataset.shareTitle;
        this.status = this.querySelector('[data-share-status]');

        const nativeButton = this.querySelector('[data-share-native]');
        const copyButton = this.querySelector('[data-share-copy]');

        // Web Share is a mobile affordance: where it exists the native sheet
        // already covers every destination, so the per-network links go away.
        if (navigator.share && nativeButton) {
          nativeButton.hidden = false;
          nativeButton.addEventListener('click', () => this.shareNative());
          this.querySelectorAll('[data-share-fallback]').forEach((link) => {
            link.hidden = true;
          });
        }

        if (navigator.clipboard && copyButton) {
          copyButton.hidden = false;
          copyButton.addEventListener('click', () => this.copyLink());
        }
      }

      async shareNative() {
        try {
          await navigator.share({ title: this.title, url: this.url });
        } catch (error) {
          // Dismissing the sheet rejects the promise; that is not a failure.
        }
      }

      async copyLink() {
        try {
          await navigator.clipboard.writeText(this.url);
          this.announce(this.dataset.copiedLabel);
        } catch (error) {
          // Clipboard writes can be denied by permissions; stay silent.
        }
      }

      announce(message) {
        if (!this.status) return;
        this.status.textContent = message;
        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => {
          this.status.textContent = '';
        }, 4000);
      }
    }

    customElements.define('share-buttons', ShareButtons);
  }
  } catch(e) { console.error(e); }
})();

})();
